import { ContainerModule } from 'inversify';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DIUploadTypes } from '@/dataroom/app/DI/FileUpload/types';
import BulkQuestionUploadDispatcherFactory from '@/dataroom/app/DI/FileUpload/BulkQuestionUploadDispatcher/index';
import type {
  IBulkQuestionUploadDispatcherFactory,
  IBulkQuestionUploadDispatcherFactoryMethod,
} from '@/dataroom/app/DI/FileUpload/BulkQuestionUploadDispatcher/interfaces';

export const BulkQuestionsModule = new ContainerModule(({ bind }) => {
  bind<IBulkQuestionUploadDispatcherFactory>(DIUploadTypes.BulkQuestionUploadDispatcherFactory)
    .to(BulkQuestionUploadDispatcherFactory)
    .inSingletonScope();

  bind<IBulkQuestionUploadDispatcherFactoryMethod>(DIUploadTypes.BulkQuestionUploadDispatcher)
    .toFactory(({ get }) =>
      (tenantCode?: DataroomTenant) =>
        get<IBulkQuestionUploadDispatcherFactory>(DIUploadTypes.BulkQuestionUploadDispatcherFactory)
        .create(tenantCode),
    );
});
